module.exports = __webpack_public_path__ + "static/media/about-why-1-image.f62e2427.png";